// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__V8GJN","checkboxCol":"Table_checkboxCol__1zAlT","emailCol":"Table_emailCol__1630b","actionCol":"Table_actionCol__3y9vY"};